export const formatCurrency = (value) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value);
};

export const formatDate = (dateString) => {
  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(new Date(dateString));
};

export const formatDistance = (km) => {
  if (km < 1) {
    return `${Math.round(km * 1000)}m`;
  }
  return `${km.toFixed(1)}km`;
};

export const getStatusLabel = (status) => {
  const labels = {
    pendente: 'Pendente',
    preparando: 'Preparando',
    coleta: 'Aguardando Coleta',
    em_rota: 'Em Rota',
    entregue: 'Entregue'
  };
  return labels[status] || status;
};

export const getStatusColor = (status) => {
  const colors = {
    pendente: 'bg-yellow-100 text-yellow-800',
    preparando: 'bg-blue-100 text-blue-800',
    coleta: 'bg-purple-100 text-purple-800',
    em_rota: 'bg-orange-100 text-orange-800',
    entregue: 'bg-green-100 text-green-800'
  };
  return colors[status] || 'bg-gray-100 text-gray-800';
};
